<template>
    <contato></contato>
</template>

<script>
import Contato from '../Contato';

export default {
    components: {
        'contato': Contato
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PaginaContato.vue